<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="verification-container flex justify-center px-4">
      <div class="flex flex-col items-start rounded bg-white p-6">
        <h3 class="mb-4 text-2xl text-dark-blue">Request Verification</h3>
        <p class="mb-4 text-left text-body-color">
          Invite this broker to verify its identity in Highway by selecting an
          email address publicly registered with the FMCSA or by entering any
          email address.
        </p>

        <p
          class="mb-2 mt-4 text-left text-xs font-bold uppercase text-dark-blue"
        >
          Broker contact details
        </p>

        <div
          v-for="email in contactEmails"
          :key="email.id"
          class="w-full pb-2"
        >
          <round-radio-button
            :item="email.value"
            :value="email.value"
            :checked="selection === email.value"
            :handle-click="handleEmailSelection"
            name="verification_email"
          />
        </div>
        <div class="w-full">
          <round-radio-button
            item="Enter email address"
            value="enter_email_address"
            :checked="selection === 'enter_email_address'"
            :handle-click="handleEmailSelection"
            name="verification_email"
          />
        </div>

        <section
          v-if="selection === 'enter_email_address'"
          class="mt-3 w-full"
        >
          <div class="flex gap-2">
            <label class="text-xs font-bold">EMAIL ADDRESS</label>
            <info-tooltip
              class="relative"
              size="sm"
              content-width-class="w-52 text-left"
            >
              <p class="text-xs leading-tight">
                The recipient of this invitation will be authenticated and
                forced to prove his or her authorization to represent this
                broker.
              </p>
            </info-tooltip>
          </div>
          <input
            v-model="emailField"
            class="font-dark-gray w-full rounded border-off-white bg-off-white px-5 py-4 hover:border-placeholder-gray focus:border-body-color focus:bg-white focus:ring-inherit"
            placeholder="Enter Email Address"
          />
        </section>

        <div class="mt-8 flex w-full items-center gap-4">
          <button-main
            variant="secondary"
            @click="$emit('close')"
          >
            Cancel
          </button-main>
          <button-main
            :disabled="disabledSubmit"
            @click="requestVerification"
          >
            Request Verification
          </button-main>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';
import RoundRadioButton from '@/components/RoundRadioButton.vue';
import InfoTooltip from '@/components/InfoTooltip.vue';
import { isEmail } from '@/common/validators';
import { toastResponse } from '@/common/handleServerResponse';

export default {
  name: 'RequestVerificationModal',
  components: {
    Modal,
    ButtonMain,
    RoundRadioButton,
    InfoTooltip,
  },
  props: {
    broker: Object,
    visible: Boolean,
    type: String,
  },
  emits: ['close', 'request-verification'],
  data() {
    return {
      selection: null,
      emailField: '',
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.users.currentUser;
    },
    contactEmails() {
      return this.$store.state.show.showBroker?.contact_information
        ?.email_addresses;
    },
    disabledSubmit() {
      if (this.selection === 'enter_email_address') {
        return !isEmail(this.emailField);
      } else {
        return !this.selection;
      }
    },
  },
  methods: {
    handleEmailSelection(e) {
      this.selection = e?.target?.value;
    },
    async requestVerification() {
      const { requested_carrier_id, company } = this.currentUser;
      const { id } = this.$props.broker || {};
      const email =
        this.selection === 'enter_email_address'
          ? this.emailField
          : this.selection;
      const cleanedEmail = email.replace(/^mailto:/, '');
      const res = await this.$store.dispatch('show/requestVerification', {
        broker_id: id,
        email: encodeURIComponent(cleanedEmail),
        carrier_id: requested_carrier_id || company.carrier_id,
      });
      if ([200, 201].includes(res.status)) {
        toastResponse(this, res, 'Invitation sent');
      } else if (res.status !== 404) {
        toastResponse(this, res, null);
      }

      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.verification-container {
  width: 500px;
}
@media screen and (max-width: 499px) {
  .verification-container {
    width: 320px;
  }
  h3 {
    @apply text-xl;
  }
}
</style>
